module.exports = __webpack_public_path__ + "img/src/components/SearchListing/MapResults/map-pin.png?0b98dcc4";